import "./Card.html";
import "./Card.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import CardComponentController from "./CardComponentController";

export class CardComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: { [slot: string]: string };

    constructor() {
        // tslint:disable:object-literal-sort-keys
        this.bindings = {
            caption: "<?", // Will hide title block if caption is not set
            subCaption: "<?",

            cardClass: "<?",

            icon: "<?",
            iconTitle: "<?",

            image: "=?",

            state: "<?",
            url: "<?",

            isLoading: "=?",
            noContent: "<?",
            noContentText: "<?",
            response: "<?",
            actionsPermission: "<?",
            hasActionsPermission: "<?",

            isExpandable: "<?",
            isExpanded: "=?",

            actions: "=?",
            onAction: "&?",

            // Convenience methods - will extend the actions array and wire click event
            add: "&?",
            edit: "&?",
            delete: "&?",

            highlightColor: "<",
        };
        this.controller = CardComponentController;
        this.templateUrl = "/App/Modules/Gui/Components/Card/Card.html";

        this.transclude = {
            content: "?mmCardContent",
            topContent: "?mmCardTopContent",
            secondBody: "?mmCardSecondBody",
        };
    }
}
